<template>
  <banner>
    <div class="grid gap-4 justify-start justify-items-start">
      <div>
        <p class="text-white font-semibold text-base">
          Activate limit of
          <span
            class="text-primaryLight font-semibold text-base"
          >{{ $filters.formatMoney(bestApprovedAmount) }}</span>
        </p>
        <p class="text-white text-xs">Complete eMandate registration</p>
      </div>
      <!-- <p class="text-white flex gap-2 items-start md:items-center text-sm">
        <img
          src="../assets/discount-badge.svg"
          alt="Badge showing percentage discount"
          width="26"
          height="26"
        />
        Upto ₹500 reward points on limit activation
      </p> -->
      <br/>
      <router-link
        :to="{ name: 'Signup' }"
        class="btn btn--normal w-full font-semibold btn--white whitespace-nowrap md:h-11"
      >Complete Registration</router-link>
    </div>
  </banner>
</template>
<script>
import { mapGetters } from 'vuex';
import Banner from './Banner.vue';

export default {
  name: 'MandateRegisterCard',
  computed: {
    ...mapGetters(['bestApprovedAmount'])
  },
  components: {
    Banner,
  },
};
</script>
